import { useEffect } from "react";

const GoogleTagManagerNoScript = ({ gtmId }) => {
  useEffect(() => {
    if (!gtmId) return;

    // Create noscript element
    const noscript = document.createElement("noscript");
    const iframe = document.createElement("iframe");

    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    iframe.title = "Google Tag Manager";

    // Append iframe to noscript and noscript to body
    noscript.appendChild(iframe);
    document.body.appendChild(noscript);

    // Cleanup: remove the noscript when component unmounts or gtmId changes
    return () => {
      document.body.removeChild(noscript);
    };
  }, [gtmId]);

  return null; // Don't render anything in the component itself
};

export default GoogleTagManagerNoScript;
